var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    'font-size': _vm.size,
    'line-height': _vm.size,
  })},[(_vm.showAmount && _vm.showAmount < 0)?_c('span',{style:({
      color: _vm.getColor,
      'font-size': _vm.size,
      'font-weight': _vm.bold ? 'bold' : 'unset',
      'line-height': _vm.size,
    })},[_vm._v("-")]):_vm._e(),(_vm.change && _vm.showAmount && _vm.showAmount > 0)?_c('span',{style:({
      color: _vm.getColor,
      'font-size': _vm.size,
      'font-weight': _vm.bold ? 'bold' : 'unset',
      'line-height': _vm.size,
    })},[_vm._v("+")]):_vm._e(),(_vm.showIcon)?_c('span',{style:({
      color: _vm.getColor,
      'font-size': '0.8em',
      'font-weight': _vm.bold ? 'bold' : 'unset',
      width: '0.9em !important',
      'line-height': '0.8em',
      display: 'inline-block',
      'line-height': _vm.size,
    })},[_vm._v("￥")]):_vm._e(),_c('span',{staticClass:"fm-padding-right-3",style:({
      color: _vm.getColor,
      'font-size': _vm.size,
      'font-weight': _vm.bold ? 'bold' : 'unset',
      'white-space': 'nowrap',
      'line-height': _vm.size,
    })},[_vm._v(_vm._s(_vm.formatPrice(_vm.showAmount)))]),(_vm.nextAmount && _vm.nextAmount != _vm.showAmount)?_c('span',{style:({
      color: 'var(--fm-secondary-text-color)',
      'font-size': '0.8em',
      'font-weight': _vm.bold ? 'bold' : 'unset',
      width: '0.7em !important',
      'line-height': '0.8em',
      position: 'relative',
      'line-height': _vm.size,
    })},[_vm._v("至")]):_vm._e(),(_vm.nextAmount && _vm.nextAmount != _vm.showAmount)?_c('span',{staticClass:"fm-padding-right-3",style:({
      color: _vm.getColor,
      'font-size': _vm.size,
      'font-weight': _vm.bold ? 'bold' : 'unset',
      'white-space': 'nowrap',
      'line-height': _vm.size,
    })},[_vm._v(_vm._s(_vm.formatPrice(_vm.nextAmount)))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14f7d4a6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fm/FmAmount.vue
// module id = null
// module chunks = 